module.exports = __webpack_public_path__ + "img/27_11.985babd2.png";